import { forwardRef, useRef } from "react";
import Card from "./Card";

const ActiveCard = forwardRef(function ActiveCard({ card }, ref) {
    return (
        <div ref={ref}>
            <Card card={card} />
        </div>
    );
});

export default ActiveCard;